// extracted by mini-css-extract-plugin
module.exports = {"pintxo-badge-wrapper":"BadgeWrapper_pintxo-badge-wrapper__wJgUj","pintxo-badge-wrapper__badge":"BadgeWrapper_pintxo-badge-wrapper__badge__q1GzW"};